import { render, staticRenderFns } from "./UpcomingFixturesTableNewOdds.vue?vue&type=template&id=9f9a76bc&"
import script from "./UpcomingFixturesTableNewOdds.vue?vue&type=script&lang=js&"
export * from "./UpcomingFixturesTableNewOdds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports